import * as t from "io-ts"
import { formatValidationErrors } from "io-ts-reporters"

export const formatErrors = (errors: t.Errors) =>
  new Error(formatValidationErrors(errors).join("\n"))

export const formatErrors2 = (errors: t.Errors) => formatValidationErrors(errors).join("\n")
